module.exports = __webpack_public_path__ + "img/SL-M-120-180.4755a333.svg";